import Swiper from 'swiper';

if (jQuery('.carousel').length) {
  // eslint-disable-next-line no-new
  new Swiper('.carousel__swiper', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
